import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import {
  createConfiguration,
  fetchConfigurations,
  fetchConfiguration,
} from '../../actions/configurationActions'
import { fetchAdminList } from '../admin/adminActions'
import { selectAdminUserList } from '../../reducers/adminUsers'
import { Configuration } from '../../core/types'
import Breadcrumb from '../../components/Breadcrumb'
import ConfigurationForm from './configurationForm'
import { selectConfigurationIndex } from '../../reducers/configurationReducer'

export interface Props {
  history: History
  createConfiguration: (values: any) => Promise<Configuration>
  fetchConfigurations: () => Promise<any>
  fetchConfiguration: (id: string) => Promise<any>
  fetchAdminList: (badges?: any) => Promise<any>
  availableTimezones: string[]
  configurations: Configuration[]
  users: any[]
}

export class ConfigurationNew extends Component<Props> {
  state = { newConfiguration: null, isLoadingUsers: true }

  private listRequested = false
  private detailRequestedForId: string | null = null
  private usersRequested = false

  componentDidMount() {
    this.ensureTimezonesLoaded()
    this.ensureUsersLoaded()
  }

  componentDidUpdate(prevProps: Props) {
    const timezonesChanged =
      prevProps.availableTimezones !== this.props.availableTimezones
    const configurationsChanged =
      prevProps.configurations !== this.props.configurations

    if ((timezonesChanged || configurationsChanged) && this.isTimezonesEmpty()) {
      this.ensureTimezonesLoaded()
    }
  }

  ensureTimezonesLoaded = () => {
    if (!this.isTimezonesEmpty()) return

    const { configurations, fetchConfigurations, fetchConfiguration } = this.props

    if (configurations && configurations.length > 0) {
      const firstId = configurations[0]?.id
      if (firstId && this.detailRequestedForId !== firstId) {
        this.detailRequestedForId = firstId
        fetchConfiguration(firstId)
      }
      return
    }

    if (!this.listRequested) {
      this.listRequested = true
      fetchConfigurations()
    }
  }

  ensureUsersLoaded = () => {
    if (!this.usersRequested && this.props.users && this.props.users.length === 0) {
      this.usersRequested = true
      this.setState({ isLoadingUsers: true })
      this.props.fetchAdminList(null).finally(() => {
        this.setState({ isLoadingUsers: false })
      })
    } else if (this.props.users && this.props.users.length > 0) {
      this.setState({ isLoadingUsers: false })
    }
  }

  isTimezonesEmpty = () =>
    !this.props.availableTimezones || this.props.availableTimezones.length === 0

  onSubmit = async (values: any) => {
    const { createConfiguration, history } = this.props
    const newConfiguration = await createConfiguration(values)
    if (newConfiguration && newConfiguration.id) {
      history.push(`/configuration/${newConfiguration.id}`)
    }
  }

  render() {
    const levels = [
      { label: 'Configurations', path: '/configuration' },
      { label: 'New', path: '' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <div className="index index__drive-america">
          <h1 className="index-table__header">New Configuration</h1>
          <ConfigurationForm
            initialValues={{}}
            timezones={this.props.availableTimezones}
            users={this.props.users}
            isLoadingUsers={this.state.isLoadingUsers}
            onSubmit={this.onSubmit}
          />
        </div>
      </>
    )
  }
}

export const mapStateToProps = (state) => {
  const configurations = selectConfigurationIndex(state.configurations) || []
  const current = state.configurations?.current
  const timezoneSource = current
    ? [...configurations, current]
    : configurations
  const allAdmins = selectAdminUserList(state.adminUsers)
  const availableTimezones = Array.from(
    new Set(
      timezoneSource.reduce<string[]>(
        (all, config) => all.concat(config.availableTimezones || []),
        []
      )
    )
  )

  return {
    availableTimezones,
    configurations,
    users: allAdmins,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    createConfiguration,
    fetchConfigurations,
    fetchConfiguration,
    fetchAdminList,
  })(ConfigurationNew)
)
